module.exports = __webpack_public_path__ + "static/media/profile-dp-lg.35f94b9d.png";